export const dividerTestIds = {
  mobileDivider: "mobile-divider",
  generalDivider: "general-divider",
};
